import React from "react"
import {Box, Paper, Stack, Typography} from "@mui/material"
import SideBarLayout from "../../../layout/side-bar-layout"
import {TITLE_DESIGN_SYSTEM_PAGE} from "../../../../utils/constants"
import StatusBadge from "../../../components/StatusBadge"
import CodeViewer from "../../../components/CodeViewer/code-viewer"

const StatusBadgeDesignSystemPage = () => {
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Status Badge`

    const codeUsage = `import StatusBadge from "src/v2/components/StatusBadge"

<StatusBadge label="Cadastro em andamento" backgroundColor="warning" />
<StatusBadge label="Cadastro em produção" backgroundColor="success" />
<StatusBadge label="Erro de validação" backgroundColor="error" />
<StatusBadge label="Custom hex" backgroundColor="#3949ab" />`

    const codeProps = `type StatusBadgeProps = {
  label?: string
  backgroundColor?: "warning" | "error" | "success" | string
}`

    return (
        <SideBarLayout
            header
            title={TITLE_PAGE}
            headerTitle={TITLE_PAGE}
        >
            <Box sx={{mt: -2}}>
                <Stack spacing={3}>
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h4" gutterBottom color="common.white">
                                {`StatusBadge`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {`Chip usado para sinalizar o estado do cadastro (andamento, produção, atenção). Utiliza as cores do tema ou qualquer cor customizada.`}
                            </Typography>

                            <Stack direction="row" spacing={2} flexWrap="wrap" mt={3}>
                                <StatusBadge label="Em andamento" backgroundColor="warning" />
                                <StatusBadge label="Publicado" backgroundColor="success" />
                                <StatusBadge label="Atenção" backgroundColor="error" />
                                <StatusBadge label="Custom" backgroundColor="#3949ab" />
                            </Stack>
                        </Box>
                    </Paper>

                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Uso básico`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`A badge é frequentemente exibida próxima ao título do formulário (FormHeader) para indicar o progresso do cadastro.`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeUsage} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Propriedades principais`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`API simples para consulta rápida.`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeProps} language="tsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>
                </Stack>
            </Box>
        </SideBarLayout>
    )
}

export default StatusBadgeDesignSystemPage
